import { render } from "./TournamentGallery.vue?vue&type=template&id=c7f8ce76&scoped=true"
import script from "./TournamentGallery.vue?vue&type=script&lang=js"
export * from "./TournamentGallery.vue?vue&type=script&lang=js"

import "./TournamentGallery.vue?vue&type=style&index=0&id=c7f8ce76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f8ce76"]])

export default __exports__